import React from 'react';
import './Speakers.css';
import VideoPresent from './VideoPresent/VideoPresent';

export default class SpeakersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            junior_speakers: [],
            junior_trackTopicsAmount: '',
            senior_speakers: [],
            senior_trackTopicsAmount: '',
        }
    }

    componentDidMount() {
        fetch(
            "https://geekle.us/api/1.1/wf/api_1_get_eventspeakers?event_track=1694788531750x951777972925497300")
            .then((res) => res.json())
            .then((json) => {
                console.log(json.responce);
                this.setState({
                    junior_speakers: json,
                    // junior_trackTopicsAmount: json.responce.trackTopicsAmount,
                });
            })
            
        fetch(
            "https://geekle.us/api/1.1/wf/api_1_get_eventspeakers?event_track=1694788536599x447138782804705300")
            .then((res) => res.json())
            .then((json) => {
                this.setState({
                    senior_speakers: json,
                    // senior_trackTopicsAmount: json.responce.trackTopicsAmount,
            });
        })
    }

    render() {
        return (
            <div className="speakers" id='speakers'>
                <VideoPresent speakersJunior={this.state.junior_speakers} speakersSenior={this.state.senior_speakers} />
            </div >
        );
    }
};